module.exports = __webpack_public_path__ + "static/img/anxun83.0275d0cd.png";